import styled from 'styled-components';

import { S26 } from '#src/atoms/icons/S26.tsx';
import { SorareLogo } from '#src/atoms/icons/SorareLogo/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import type { Unit } from '#src/lib/style.ts';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';
import type { Color, HexColorOnly } from '#src/style/types.ts';

const StyledSorareLogo = styled(SorareLogo)`
  .large & {
    @container ${tabletAndAbove} {
      height: calc(4.5 * var(--unit));
      width: calc(30 * var(--unit));
    }
  }

  .small & {
    height: var(--double-unit);
    width: calc(13 * var(--unit));
  }
`;

type Props = {
  gap?: 'small' | 'large';
  iconSize?: Unit;
  size?: 'small' | 'medium' | 'large';
  color?: Color | HexColorOnly;
};

export const NewSeasonLogo = ({
  gap = 'large',
  size = 'medium',
  iconSize = 7,
  color = 'var(--c-white)',
}: Props) => {
  return (
    <Horizontal gap={gap === 'small' ? 1 : 2} className={gap}>
      <StyledSorareLogo size={size} color={color} />
      <S26 size={iconSize} color={color} />
    </Horizontal>
  );
};
